import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {EventFormQuestion} from '../api/event-api.service';
import {newFormId} from './registration-questions.util';

/**
 * Organizer side: define the questions attendees answer when registering. Edits the passed array in place
 * and also emits it, so parents can use either one-way binding or [(questions)].
 * Used on all three event editors (chapter-event add + edit modals, event-home edit form).
 */
@Component({
    selector: 'app-question-editor',
    templateUrl: './question-editor.component.html',
    styleUrls: ['./question-editor.component.css']
})
export class QuestionEditorComponent {
    @Input() questions: EventFormQuestion[] = [];
    /** Unique per editor instance so generated input ids/names never collide across modals. */
    @Input() idPrefix = 'rq';
    @Output() questionsChange = new EventEmitter<EventFormQuestion[]>();

    readonly maxQuestions = 20;
    readonly maxOptions = 20;

    addQuestion(): void {
        if (this.questions.length >= this.maxQuestions) { return; }
        this.questions.push({
            questionId: newFormId(),
            label: '',
            type: 'SINGLE_SELECT',
            required: false,
            options: [{optionId: newFormId(), label: ''}, {optionId: newFormId(), label: ''}]
        });
        this.changed();
    }

    removeQuestion(i: number): void {
        this.questions.splice(i, 1);
        this.changed();
    }

    addOption(q: EventFormQuestion): void {
        if (q.options.length >= this.maxOptions) { return; }
        q.options.push({optionId: newFormId(), label: ''});
        this.changed();
    }

    removeOption(q: EventFormQuestion, i: number): void {
        q.options.splice(i, 1);
        this.changed();
    }

    drop(event: CdkDragDrop<EventFormQuestion[]>): void {
        moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
        this.changed();
    }

    // cdkDropList repositions DOM nodes ahead of change detection; tracking by index keeps the
    // ngModel-bound inputs in sync (same reason the ticket-option panels do this).
    trackByIndex(index: number): number {
        return index;
    }

    changed(): void {
        this.questionsChange.emit(this.questions);
    }
}
